import jsforce from "jsforce";

export let SFDC;

export const init = options => {
  SFDC = new jsforce.Connection(options);
};
